import BaseWrapper from "../../components/BaseWrapper/BaseWrapper";
import { useEffect, useState } from "react";
import { API } from "../../lib/api";
import Feedback from "../../components/Feedback/Feedback";
import { Box, CircularProgress, FormControlLabel, Switch } from "@mui/material";
import { FormProvider } from "../../contexts/CreateRecordFormContext";
import ContactsColumns from "../../lib/TableColumns/ContactsColumns"
import CollapsibleGridCard from "../../components/CollapsibleGridCard";
import { useAuth } from "../../contexts/AuthContext";
import { GRID_SESSION_KEYS, readGridSessionState } from "../../lib/gridSessionState";
import { buildContactDuplicateRows } from "../../lib/contactDuplicates";
import ContactDuplicatesDialog from "../../components/ContactDuplicatesDialog";

const Contacts = () => {
    const [contacts, setContacts] = useState([]) 
    const [loading, setLoading] = useState(true);
    const [feedback, setFeedback] = useState({open: false, message: "", type: ""}) 
    const [comparison, setComparison] = useState(null);
    const columns = ContactsColumns({ onCompareDuplicates: setComparison });
    const { user } = useAuth();
    const sessionUserId = user?.userId || localStorage.getItem("id");
    const [filterModel, setFilterModel] = useState(() => readGridSessionState(GRID_SESSION_KEYS.contacts, sessionUserId)?.filterModel || { items: [] });
    const duplicatesOnly = filterModel.items.some(item => item.id === 'duplicates-only');
    const toggleDuplicates = (_, checked) => setFilterModel(previous => ({
        ...previous,
        items: [
            ...previous.items.filter(item => item.id !== 'duplicates-only'),
            ...(checked ? [{ id: 'duplicates-only', field: 'duplicateCount', operator: '>', value: '0' }] : []),
        ],
    }));
    
    useEffect(() => {
        async function getData() {
            try {
                const response = await API.Customers.FetchAll()
                const allContacts = buildContactDuplicateRows(response);
                setContacts(allContacts)   
            } catch (error) {
                setFeedback(prevData => ({ ...prevData, open: true, message: 'Error: Failed To Load Customers...', type: "error" }))
            } finally {
                setLoading(false)
            }
        }
        getData()
    },[])

    return (
        <BaseWrapper content={
            <>
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                        <CircularProgress />
                    </Box>
                ) : (
                    <FormProvider>
                        <Feedback props={feedback} setFeedback={setFeedback} />
                        <ContactDuplicatesDialog contact={comparison} contacts={contacts} onClose={() => setComparison(null)} />
                        <CollapsibleGridCard
                            title="Contacts"
                            linkLabel="All Contacts"
                            filterNode={<FormControlLabel control={<Switch checked={duplicatesOnly} onChange={toggleDuplicates} />} label="Show duplicates only" />}
                            rows={duplicatesOnly ? contacts.filter(contact => contact.duplicateCount > 0) : contacts}
                            columns={columns}
                            sessionStorageKey={GRID_SESSION_KEYS.contacts}
                            sessionUserId={sessionUserId}
                            getRowId={(row) => row._id}
                            checkboxSelection
                            initialPageSize={25}
                            pageSizeOptions={[25, 50, 100]}
                            extraGridProps={{ filterModel, onFilterModelChange: setFilterModel }}
                        />
                    </FormProvider>    
                )}   
            </> 
        } />
    )
}

export default Contacts
